<template>
  <div class="map-google">
    <div
      v-if="loading"
      class="map-google-load"
    >
      <div class="lds-default">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="map-google-count"
    >
      {{ markers.length }} Einträge
    </div>
    <div class="map-google-map" id="map-google-map" ref="map-google-map"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'MapGoogle',
    data () {
        return {
            map: null,
            oms: null,
        };
    },
    async mounted () {
        this.initGoogleMaps().then(async () => {
            await this.initMap();
            await this.initOms();
            this.initInfoWindow();

            this.updateMarkers();
        });
    },
    computed: {
        ...mapState('facets', [
            'loading',
            'markers',
        ]),
    },
    methods: {
        ...mapActions('facets', [
            'updateMarkers',
        ]),
        initGoogleMaps () {
            const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
            return new Promise((resolve, reject) => {
                if (window.google) {
                    return resolve();
                }

                if (!apiKey) {
                    return reject();
                }

                window.googleMapsLoaded = resolve;

                const script = document.createElement('script');

                script.type = 'text/javascript';
                script.async = true;
                script.defer = true;
                script.src = 'https://maps.googleapis.com/maps/api/js?'
                    + 'key=' + apiKey
                    + '&callback=googleMapsLoaded';

                script.onerror = reject;

                document.querySelector('head').appendChild(script);
            });
        },
        initMap () {
            return new Promise((resolve, reject) => {
                if (this.map) {
                    return reject();
                }

                const element = this.$refs[ 'map-google-map' ];
                this.map = new window.google.maps.Map(element, {
                    center: { lat: 53.5511, lng: 9.9937 },
                    zoom: 11,
                    styles: [
                        {
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#f5f5f5' },
                            ],
                        },
                        {
                            'elementType': 'labels.icon',
                            'stylers': [
                                { 'visibility': 'off' },
                            ],
                        },
                        {
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#616161' },
                            ],
                        },
                        {
                            'elementType': 'labels.text.stroke',
                            'stylers': [
                                { 'color': '#f5f5f5' },
                            ],
                        },
                        {
                            'featureType': 'administrative.land_parcel',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#bdbdbd' },
                            ],
                        },
                        {
                            'featureType': 'poi',
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#eeeeee' },
                            ],
                        },
                        {
                            'featureType': 'poi',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#757575' },
                            ],
                        },
                        {
                            'featureType': 'poi.park',
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#e5e5e5' },
                            ],
                        },
                        {
                            'featureType': 'poi.park',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#9e9e9e' },
                            ],
                        },
                        {
                            'featureType': 'road',
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#ffffff' },
                            ],
                        },
                        {
                            'featureType': 'road.arterial',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#757575' },
                            ],
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#dadada' },
                            ],
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#616161' },
                            ],
                        },
                        {
                            'featureType': 'road.local',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#9e9e9e' },
                            ],
                        },
                        {
                            'featureType': 'transit.line',
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#e5e5e5' },
                            ],
                        },
                        {
                            'featureType': 'transit.station',
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#eeeeee' },
                            ],
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'geometry',
                            'stylers': [
                                { 'color': '#c9c9c9' },
                            ],
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                { 'color': '#9e9e9e' },
                            ],
                        },
                    ],
                });
                window.map = this.map;

                return resolve();
            });
        },
        initOms () {
            return new Promise((resolve, reject) => {
                if (window.OverlappingMarkerSpiderfier) {
                    return reject();
                }

                const script = document.createElement('script');

                script.type = 'text/javascript';
                script.async = true;
                script.defer = true;
                script.src = 'https://cdnjs.cloudflare.com/ajax/libs/OverlappingMarkerSpiderfier/1.0.3/oms.min.js';
                script.onerror = reject;
                script.onload = () => {
                    this.oms = new window.OverlappingMarkerSpiderfier(
                        this.map,
                        { legWeight: 3 },
                    );
                    window.oms = this.oms;
                    resolve();
                };

                document.querySelector('head').appendChild(script);
            });
        },
        initInfoWindow () {
            window.infoWindow = this.infoWindow = new window.google.maps.InfoWindow({
                content: '',
            });

            this.oms.addListener('click', (marker, event) => {
                const overlay = new window.google.maps.OverlayView();
                overlay.draw = () => {
                };
                overlay.setMap(window.map);
                const projection = overlay.getProjection();

                const eventPixelCoords = projection.fromLatLngToDivPixel(event.latLng);

                if (eventPixelCoords.y < 100) {
                    let point = window.map.getCenter();

                    const pixelPoint = projection.fromLatLngToDivPixel(point);
                    pixelPoint.y -= (100 - eventPixelCoords.y);

                    point = projection.fromDivPixelToLatLng(pixelPoint);

                    window.map.panTo(point);
                }

                this.infoWindow.open(window.map, marker);
            });
            this.oms.addListener('spiderfy', () => {
                this.infoWindow.close();
            });
        },
    },
};
</script>

<style scoped>
.map-google {
  position: relative;
  flex-grow: 1;
  border-radius: 2px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  min-height: 95vh;
  display: flex;
  margin-bottom: 20px;
}

.map-google-map {
  flex-grow: 1;
}

.map-google-load {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.15);
}

.map-google-count {
  position: absolute;
  z-index: 99;
  color: rgb(86, 86, 86);
  background-color: #fff;
  padding: 0 17px;
  margin: 10px 190px;
  height: 40px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 18px;
  font-family: Roboto, Arial, sans-serif;
}
</style>

<style>
.panelPhoto {
  max-width: 100%;
  height: 400px;
  border: 1px solid #ddd;
}

.row {
  display: flex;
  justify-content: space-between;
}

.photoContent {
  margin: auto;
}

.col-md-4 {
  margin: 10px 0;
}

.form-control {
  border: 1px solid #ddd;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  margin: 4px;
  background-color: white;
  padding: 5px 8px;
  cursor: pointer;
  font-size: 14px;
  width: 90px;
}

.photoTitle {
  font-size: 19px;
  line-height: 20px;
  font-weight: bold;
  font-family: TheSansUHH-Caps, sans-serif;
}

.photoTitle h4 {
  margin-top: 10px;
  margin-bottom: 2px;
}

#divPhotoInfo {
  min-height: 405px;
}

#divPhotoInfo table th {
  text-align: left;
}

#divPhotoInfo table {
  border: 1px solid #ddd;
  width: 100%;
  margin-bottom: 20px;
  padding: 5px 10px;
}

#divPhotoInfo table td {
  padding-right: 10px;
}

#divPhotoStreetView {
  width: 405px;
  height: 405px;
  border: 1px solid #ddd;
}


.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #027bcb;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

.lds-default {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  transform: scale(1.5);
}

.lds-default div {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #e2001a;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 29px;
  left: 53px;
}

.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 18px;
  left: 50px;
}

.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 9px;
  left: 41px;
}

.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 6px;
  left: 29px;
}

.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  top: 9px;
  left: 18px;
}

.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 18px;
  left: 9px;
}

.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 29px;
  left: 6px;
}

.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 41px;
  left: 9px;
}

.lds-default div:nth-child(9) {
  animation-delay: -0.8s;
  top: 50px;
  left: 18px;
}

.lds-default div:nth-child(10) {
  animation-delay: -0.9s;
  top: 53px;
  left: 29px;
}

.lds-default div:nth-child(11) {
  animation-delay: -1s;
  top: 50px;
  left: 41px;
}

.lds-default div:nth-child(12) {
  animation-delay: -1.1s;
  top: 41px;
  left: 50px;
}

@keyframes lds-default {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}


</style>
